export interface EventTypes {
  category: string;
  action: string;
  label: string;
}

/*
All common events in each module:
- Job Submission
- Result for single SMILE
- Visualize Result
- Evaluation Result
*/

// all modules
export const allModulesCategories: Record<string, string> = {
  dashboard: "Dashboard",
  maiMol: "MAIMol",
  ranker: "ranker", // done
  autodock: "AutoDock",
  unidock: "UniDock",
  screenie: "screenie", // done
  liftVisualizer: "lift Visualizer", // done
  liftFilter: "lift Filter", // done
  genFil: "GenFil",
  admetPro: "adme_tox", // done
  leaderReinvent: "reinvent", // done
  bioSwap: "bioiso", // done
  substituteR: "SubstituteR",
  lodestar: "Lodestar", // done
  // moleculeCopilot: "Molecule Copilot", // done
  molBench: "MolBench", //done
  drViz: "Dr Viz",
  clusterPro: "clusterPro",
  hopper: "hopper",
  fileConverter : "fileConverter",
  genie : "genie",
};

export const allModuleEvents: Record<string, EventTypes> = {
  job: {
    category: "Job",
    action: "Job Submission",
    label: "Job Submission Form",
  },
  single_smile: {
    category: "Single Smile",
    action: "Single SMILE Result",
    label: "Fetched Single SMILE Result",
  },
  visualization: {
    category: "Visualization",
    action: "Visualization Result",
    label: "Checked Visalization Result",
  },
  evaluation: {
    category: "Evaluation",
    action: "Evaluation Result",
    label: "Checked Evaluation Result",
  },
  pdb_id: {
    category: "PDB ID",
    action: "PDB ID Result",
    label: "Checked Result with PDB ID",
  },
  pdb_id_and_file: {
    category: "PDB ID + PDB File",
    action: "PDB ID + PDB File Result",
    label: "Checked Result with PDB ID and PDB File",
  },
  pdb_file_and_ligand: {
    category: "PDB File + Ligand(File or Smile)",
    action: "PDB File + Ligand(File or Smile) Result",
    label: "Checked Result with PDB File and Ligand(File or Smile)",
  },
  view_interactions: {
    category: "View Interactions",
    action: "View Interactions",
    label: "Checked Interactions",
  },
  view_docking_score: {
    category: "View Docking Score",
    action: "View Docking Score",
    label: "Checked Docking Score",
  },
  download_result: {
    category: "Download Result",
    action: "Download Result",
    label: "Download Result",
  },
  create_session: {
    category: "Session Created",
    action: "Session Created",
    label: "Session has been created",
  },
  get_mol_properties: {
    category: "Properties",
    action: "Properties",
    label: "Checked Molecular Properties",
  },
  get_modifications: {
    category: "Modifications",
    action: "Modifications",
    label: "Checked Modifications",
  },
};
